import * as React from "react";
import { Control, useController, useWatch } from "react-hook-form";

import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";

import { isEmpty } from "lodash";

import { CONTACT_RELATIONSHIP } from "constants/patients";

import { AppointmentFormValues } from "../appointment-form.component";

type CompanionFieldProps = {
  control: Control<AppointmentFormValues, object>;
};

export default function CompanionField({ control }: CompanionFieldProps) {
  const { field: companionTypeField } = useController({
    name: "companion_type",
    control
  });
  const {
    field: companionNameField,
    formState: { errors }
  } = useController({
    name: "companion_name",
    control,
    rules: {
      validate: (value) =>
        isEmpty(companionType) ||
        !isEmpty(value) ||
        "Companion Name is required"
    }
  });

  const companionType = useWatch({ control, name: "companion_type" });
  return (
    <Stack flexDirection="row" gap={2}>
      <Box
        width="50%"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <PersonOutlineOutlinedIcon sx={{ mt: 1.5, mr: 1.5 }} color="action" />
        <TextField
          id="companion_type"
          label="Companion type"
          select
          SelectProps={{
            IconComponent: ExpandMoreOutlinedIcon
          }}
          fullWidth
          {...companionTypeField}
        >
          {CONTACT_RELATIONSHIP.getOptions().map(({ label, value }) => (
            <MenuItem key={[value, label].join("_")} value={value}>
              {label}
            </MenuItem>
          ))}
        </TextField>
      </Box>

      <Box
        width="50%"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <TextField
          label="Companion Name"
          fullWidth
          {...(Boolean(errors?.companion_name?.message)
            ? { error: true, helperText: errors?.companion_name?.message }
            : {})}
          {...companionNameField}
        />
      </Box>
    </Stack>
  );
}
